import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "../lib/transitions"

export default class extends Controller {
  static targets = [ "container", "background", "panel" ]

  close() {
    leave(this.backgroundTarget)
    leave(this.panelTarget)
    setTimeout(() => {
      this.containerTarget.classList.add("hidden")
    }, 500)
  }

  open() {
    this.containerTarget.classList.remove("hidden")
    this.containerTarget.classList.add("flex")
    enter(this.backgroundTarget)
    enter(this.panelTarget)

  }

  connect() {

  }
}
